import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface MasterClassFiltersProps {
  sortBy: string;
  onSortChange: (sort: string) => void;
}

export function MasterClassFilters({
  sortBy,
  onSortChange
}: MasterClassFiltersProps) {
  useLanguage();
  return (
    <div className="flex justify-end mb-8">
      {/* Ordenação */}
      <Select value={sortBy} onValueChange={onSortChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder={translateInterfaceText("Ordenar por")} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="progress">{translateInterfaceText("Em andamento")}</SelectItem>
          <SelectItem value="recent">{translateInterfaceText("Mais recentes")}</SelectItem>
          <SelectItem value="popular">{translateInterfaceText("Mais vistos")}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
